import {CountryDomainModel} from "../../../common/country/models/country-domain-model";
import {SportDomainModel} from "../../../sports/models/sport-domain-model";
import {GameH2hCompetitorApiModel} from "./game-h2h.competitor.api-model";
import {GameCompetitorDomainModel} from "../../../partial-game/models/game-competitor/game-competitor-domain-model";
import {PartialGameDomainModel} from "../../../partial-game/models/partial-game-domain-model";
import {GameH2hCompetitorLayoutDataDomainModel} from "./game-h2h.competitor.layout-data.domain-model";

export class GameH2hCompetitorDomainModel extends GameCompetitorDomainModel {
  apiModel: GameH2hCompetitorApiModel;
  recentGames: Array<PartialGameDomainModel> = [];

  constructor(apiModel: GameH2hCompetitorApiModel, country: CountryDomainModel, sport: SportDomainModel, recentGames: Array<PartialGameDomainModel>) {
    super(apiModel, country, sport);

    this.recentGames = recentGames;
  }

  get lastMatchesLayoutData(): GameH2hCompetitorLayoutDataDomainModel {
    return this.apiModel.lastMatchesLayoutData ? new GameH2hCompetitorLayoutDataDomainModel(this.apiModel.lastMatchesLayoutData) : null;
  }
}
